import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _typeof from "@babel/runtime/helpers/typeof";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import update from 'immutability-helper';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import QuestionRenderer from '../QuestionRenderer';
import { getRequest, putRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import './QuestionsContainer.scss';
var processAnswer = function processAnswer(answer) {
  return answer.map(function (ans) {
    var hash = {};
    ans.forEach(function (a) {
      hash[a.column_name] = a.value && _typeof(a.value) === 'object' && !(a.value instanceof Date) ? a.value.value : a.value;
    });
    hash.id = ans[0].id;
    return hash;
  });
};
var isValidAnswer = function isValidAnswer(question) {
  if (question.question_type === 'proficiency_ranking') {
    return question.answer.some(function (ans) {
      return ans.ranking;
    });
  }
  return question.answer.length > 0;
};
var QuestionsContainer = /*#__PURE__*/function (_Component) {
  function QuestionsContainer(props) {
    var _this;
    _classCallCheck(this, QuestionsContainer);
    _this = _callSuper(this, QuestionsContainer, [props]);

    // if paginated, the initial state of questionIds should be the first element
    // of paginatedQuestionIds.
    var initialQuestionIds = props.paginated ? props.paginatedQuestionIds[0] : props.questionIds;
    _this.state = {
      modalStep: 0,
      questions: [],
      questionIds: initialQuestionIds
    };
    _this.getCurrentQuestions = _this.getCurrentQuestions.bind(_this);
    _this.renderQuestions = _this.renderQuestions.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleProficiencyChange = _this.handleProficiencyChange.bind(_this);
    _this.handleProficiencyRankingChange = _this.handleProficiencyRankingChange.bind(_this);
    _this.handleOtherTextChange = _this.handleOtherTextChange.bind(_this);
    _this.updateQuestionAnswer = debounce(_this.updateQuestionAnswer.bind(_this), 500);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleModalNext = _this.handleModalNext.bind(_this);
    _this.handleModalBack = _this.handleModalBack.bind(_this);
    _this.isQuestionDisabled = _this.isQuestionDisabled.bind(_this);
    _this.updateQuestionState = _this.updateQuestionState.bind(_this);
    return _this;
  }
  _inherits(QuestionsContainer, _Component);
  return _createClass(QuestionsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateQuestionState();
    }
  }, {
    key: "getCurrentQuestions",
    value: function getCurrentQuestions() {
      var _this$props = this.props,
        questionableId = _this$props.questionableId,
        questionableType = _this$props.questionableType;
      var questionIds = this.state.questionIds;
      return getRequest('/question_answers/questions', {
        questionnaire_question_ids: questionIds,
        questionable_id: questionableId,
        questionable_type: questionableType
      });
    }
  }, {
    key: "setModalStep",
    value: function setModalStep(newModalStep) {
      var paginatedQuestionIds = this.props.paginatedQuestionIds;
      this.setState({
        modalStep: newModalStep,
        questionIds: paginatedQuestionIds[newModalStep]
      }, this.updateQuestionState);
    }
  }, {
    key: "getHandleChangeCallback",
    value: function getHandleChangeCallback(question) {
      switch (question.question_type) {
        case 'proficiency':
          return this.handleProficiencyChange;
        case 'proficiency_ranking':
          return this.handleProficiencyRankingChange;
        default:
          return this.handleInputChange;
      }
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      var _this$props2 = this.props,
        closeModalCallback = _this$props2.closeModalCallback,
        paginated = _this$props2.paginated;
      if (paginated) {
        this.setModalStep(0); // will call updateQuestionState as a setState callback
      } else {
        this.updateQuestionState();
      }
      closeModalCallback();
    }
  }, {
    key: "handleModalBack",
    value: function handleModalBack() {
      var modalStep = this.state.modalStep;
      if (modalStep === 0) return;
      this.setModalStep(modalStep - 1);
    }
  }, {
    key: "handleModalNext",
    value: function handleModalNext() {
      var modalStep = this.state.modalStep;
      if (this.shouldCloseModal()) {
        this.handleCloseModal();
      } else {
        this.setModalStep(modalStep + 1);
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value, key, name) {
      var debounceUpdate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var _this$props3 = this.props,
        questionsUpdated = _this$props3.questionsUpdated,
        questionableId = _this$props3.questionableId,
        questionableType = _this$props3.questionableType,
        csrfToken = _this$props3.csrfToken,
        questionnaireName = _this$props3.questionnaireName,
        handleToggleSave = _this$props3.handleToggleSave;
      var questions = this.state.questions;
      var question;
      if (key === 'project lead about') {
        question = questions.find(function (q) {
          return q.question_key === 'project_lead_about';
        });
      } else {
        question = questions.find(function (q) {
          return q.question_key === key;
        });
      }
      var errorFound = false;
      switch (question.question_type) {
        case 'list':
          question.answer = value.filter(Boolean);
          break;
        case 'location':
          handleToggleSave(true);
          question.answer = value;
          break;
        case 'numeric_range':
          if (question.answer === null) question.answer = {};
          question.answer[name] = value;
          if (name === 'low' && parseInt(question.answer.high, 10) < parseInt(value, 10) || name === 'high' && parseInt(value, 10) < parseInt(question.answer.low, 10)) {
            errorFound = true;
          }
          break;
        case 'date_range':
          if (question.answer === null) question.answer = {};
          question.answer[name] = value;
          break;
        case 'select_one':
        case 'only_custom_tags':
        case 'select_many':
        case 'proficiency_ranking':
        case 'freetext':
        case 'number':
        case 'past_roles':
        case 'boolean':
        case 'group_parent':
        default:
          question.answer = value;
      }
      this.setState({
        questions: questions
      });
      questionsUpdated();
      if (errorFound) {
        return null;
      }
      if (debounceUpdate) {
        return this.updateQuestionAnswer(question);
      }
      var ans = question.answer;
      if (question.question_type === 'group_parent') {
        ans = processAnswer(question.answer);
      }
      return putRequest("/question_answers/".concat(question.id), {
        questionable_type: questionableType,
        questionable_id: questionableId,
        question_answer: {
          answer: _defineProperty({}, question.question_type, ans)
        },
        questionnaire_name: questionnaireName
      }, csrfToken);
    }
  }, {
    key: "handleProficiencyChange",
    value: function handleProficiencyChange(newProficiency, key, idx) {
      var _this$props4 = this.props,
        questionableType = _this$props4.questionableType,
        questionableId = _this$props4.questionableId,
        questionsUpdated = _this$props4.questionsUpdated,
        csrfToken = _this$props4.csrfToken,
        questionnaireName = _this$props4.questionnaireName;
      var questions = this.state.questions;
      var question = questions.find(function (q) {
        return q.question_key === key;
      });
      var currentAnswer = question.answer[idx];
      var newAnswer = update(currentAnswer, {
        proficiency: {
          $set: newProficiency
        }
      });
      question.answer[idx] = newAnswer;
      this.setState({
        questions: questions
      });
      questionsUpdated();
      return putRequest("/question_answers/".concat(question.id), {
        questionable_type: questionableType,
        questionable_id: questionableId,
        question_answer: {
          answer: {
            proficiency: newAnswer
          }
        },
        questionnaire_name: questionnaireName
      }, csrfToken);
    }
  }, {
    key: "handleProficiencyRankingChange",
    value: function handleProficiencyRankingChange(questionKey, ranked, unranked) {
      var _this$props5 = this.props,
        questionableType = _this$props5.questionableType,
        questionableId = _this$props5.questionableId,
        questionsUpdated = _this$props5.questionsUpdated,
        csrfToken = _this$props5.csrfToken,
        questionnaireName = _this$props5.questionnaireName;
      var questions = this.state.questions;
      var question = questions.find(function (q) {
        return q.question_key === questionKey;
      });
      question.answer = ranked.concat(unranked);
      this.setState({
        questions: questions
      });
      questionsUpdated();
      return putRequest("/question_answers/".concat(question.id), {
        questionable_type: questionableType,
        questionable_id: questionableId,
        question_answer: {
          answer: {
            ranked: ranked,
            unranked: unranked
          }
        },
        questionnaire_name: questionnaireName
      }, csrfToken);
    }
  }, {
    key: "handleOtherTextChange",
    value: function handleOtherTextChange(value, key) {
      var questions = this.state.questions;
      var question = questions.find(function (q) {
        return q.question_key === key;
      });
      var other = question.answer.find(function (x) {
        return typeof x.value === 'string' && x.value.includes('custom:');
      });
      if (other) {
        other.label = value;
        other.value = "custom:".concat(value);
      } else {
        var otherValue = {
          label: value,
          value: "custom:".concat(value)
        };
        question.answer.push(otherValue);
      }
      this.setState({
        questions: questions
      });
      this.updateQuestionAnswer(question);
    }
  }, {
    key: "isQuestionDisabled",
    value: function isQuestionDisabled(question) {
      var questions = this.state.questions;
      if (question.parent_id === null || question.question_type === 'proficiency_ranking' || question.question_type === 'proficiency') return false;
      var parent = questions.find(function (q) {
        return q.question_id === question.parent_id;
      });
      if (parent && parent.question_type === 'select_one' && parent.answer) {
        var parentAnswer = parent.answer.value;
        if (question.trigger_type === 'hide' && parentAnswer === 'yes') {
          return true;
        }
        if ((question.trigger_type === 'show' || question.trigger_type === 'disable') && parentAnswer === 'no') {
          return true;
        }
        return false;
      }
      if (parent && parent.question_type === 'boolean') {
        if ((question.trigger_type === 'hide' || question.trigger_type === 'disable') && parent.answer === 'true') {
          return true;
        }
        return false;
      }
      return true;
    }
  }, {
    key: "updateQuestionAnswer",
    value: function updateQuestionAnswer(question) {
      var _this2 = this;
      var _this$props6 = this.props,
        csrfToken = _this$props6.csrfToken,
        questionnaireName = _this$props6.questionnaireName,
        suggestedAnswers = _this$props6.suggestedAnswers,
        questionableId = _this$props6.questionableId,
        questionableType = _this$props6.questionableType,
        handleToggleSave = _this$props6.handleToggleSave;
      return putRequest("/question_answers/".concat(question.id), {
        questionable_type: questionableType,
        questionable_id: questionableId,
        question_answer: {
          answer: _defineProperty({}, question.question_type, question.answer)
        },
        questionnaire_name: questionnaireName
      }, csrfToken).then(function () {
        var properties = {
          question_key: question.question_key,
          location: questionnaireName
        };
        var suggestedAnswer = suggestedAnswers && suggestedAnswers[question.question_key] && suggestedAnswers[question.question_key.map(function (s) {
          return s.name;
        })];
        if (question.question_type === 'select_many' && suggestedAnswer && question.answer.some(function (item) {
          return suggestedAnswer.includes(item.label);
        })) {
          properties.picked_suggested_answer = true;
        }
        // Update Roles question so options can reflect selected AOE's
        if (question.question_key === 'functional_areas' && questionnaireName === 'Consultant Onboarding') {
          _this2.updateQuestionState();
        }
        analyticsTrack('Answered a Question', properties);
        _this2.props.handleMenuUpdate(true);
        handleToggleSave(false);
      });
    }
  }, {
    key: "updateQuestionState",
    value: function updateQuestionState() {
      var _this3 = this;
      this.getCurrentQuestions().then(function (response) {
        _this3.setState({
          questions: response.data
        });
        _this3.props.loadButtons();
        if (response.data && response.data.some(function (question) {
          return question.answer;
        })) {
          _this3.props.questionsUpdated();
        }
      });
    }
  }, {
    key: "shouldCloseModal",
    value: function shouldCloseModal() {
      var _this4 = this;
      var _this$props7 = this.props,
        paginatedQuestionIds = _this$props7.paginatedQuestionIds,
        paginated = _this$props7.paginated;
      var _this$state = this.state,
        modalStep = _this$state.modalStep,
        questions = _this$state.questions;
      if (!paginated || paginatedQuestionIds.length === 0) {
        // error handling/catching - not a paginated question or no paginatedQuestions to display
        return true;
      }
      if (modalStep === paginatedQuestionIds.length - 1) {
        // on last modal step, so close modal
        return true;
      }
      if (questions.every(function (q) {
        return !q.paginated_modal || !isValidAnswer(q);
      })) {
        // all answers given are invalid on this page, so close modal.
        return true;
      }
      if (questions.some(function (q) {
        return _this4.isQuestionDisabled(q);
      })) {
        // some question on current page is disabled, so close modal rather than going to next step.
        return true;
      }

      // default, do not close modal
      return false;
    }
  }, {
    key: "renderQuestions",
    value: function renderQuestions() {
      var _this5 = this;
      var _this$state2 = this.state,
        questions = _this$state2.questions,
        modalStep = _this$state2.modalStep;
      var _this$props8 = this.props,
        csrfToken = _this$props8.csrfToken,
        owner = _this$props8.owner,
        forceSmallQuestionTitle = _this$props8.forceSmallQuestionTitle,
        suggestedAnswers = _this$props8.suggestedAnswers,
        saveOnChange = _this$props8.saveOnChange,
        questionnaireName = _this$props8.questionnaireName,
        handleMenuUpdate = _this$props8.handleMenuUpdate,
        userId = _this$props8.userId,
        loadButtons = _this$props8.loadButtons,
        handleNewResume = _this$props8.handleNewResume,
        handleToggleSave = _this$props8.handleToggleSave,
        objectId = _this$props8.objectId,
        isReadingMore = _this$props8.isReadingMore,
        handleResumeUpload = _this$props8.handleResumeUpload,
        handlePastRolesAfterUpdate = _this$props8.handlePastRolesAfterUpdate;
      var onboardingQuestionnaire = questionnaireName === 'Consultant Onboarding';
      return /*#__PURE__*/React.createElement("div", {
        className: "questions-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "question-renderer ".concat(onboardingQuestionnaire ? 'onboarding-questionnaire' : '')
      }, questions.map(function (q) {
        return /*#__PURE__*/React.createElement(QuestionRenderer, {
          question: q,
          handleChange: _this5.getHandleChangeCallback(q),
          handleOtherTextChange: _this5.handleOtherTextChange,
          csrfToken: csrfToken,
          key: "".concat(q.id, "-").concat(modalStep),
          disabled: _this5.isQuestionDisabled(q),
          owner: owner,
          userId: userId,
          closeModal: _this5.handleCloseModal,
          forceSmallQuestionTitle: forceSmallQuestionTitle,
          suggestedAnswers: suggestedAnswers,
          saveOnChange: saveOnChange,
          questionnaireName: questionnaireName,
          handleMenuUpdate: handleMenuUpdate,
          loadButtons: loadButtons,
          handleNewResume: handleNewResume,
          updateParentError: handleToggleSave,
          objectId: objectId,
          isReadingMore: isReadingMore,
          handleResumeUpload: handleResumeUpload,
          handlePastRolesAfterUpdate: handlePastRolesAfterUpdate
        });
      })));
    }
  }, {
    key: "renderNavButtons",
    value: function renderNavButtons() {
      var _this$props9 = this.props,
        paginatedQuestionIds = _this$props9.paginatedQuestionIds,
        paginated = _this$props9.paginated;
      var _this$state3 = this.state,
        questions = _this$state3.questions,
        modalStep = _this$state3.modalStep;
      if (!paginated) {
        return /*#__PURE__*/React.createElement(Button, {
          variant: "primary",
          onClick: this.handleCloseModal
        }, "Save");
      }
      if (!questions || !questions.length) return null;
      var nextDisabled = questions.reduce(function (aggr, question) {
        var answerMissing = question.question_type === 'proficiency' ? question.answer.some(function (a) {
          return !a.proficiency;
        }) : false;
        return aggr || answerMissing;
      }, false);

      // If not on the last step of a paginated question
      // button gets rendered in the middle.
      if (modalStep === 0) {
        return /*#__PURE__*/React.createElement(Button, {
          variant: "primary",
          onClick: this.handleModalNext,
          disabled: nextDisabled
        }, "Next");
      }

      // last step (proficiency nav buttons: Save, Back, Skip)
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "secondary back-button",
        onClick: this.handleModalBack
      }, "Back")), /*#__PURE__*/React.createElement(Col, {
        xs: 6
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "primary save-button",
        onClick: this.handleModalNext,
        disabled: nextDisabled
      }, modalStep < paginatedQuestionIds.length - 1 ? 'Next' : 'Save'))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        xs: 12
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "secondary skip-button",
        onClick: this.handleCloseModal
      }, "Skip"))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
        withModal = _this$props10.withModal,
        hideFooterButton = _this$props10.hideFooterButton,
        questionType = _this$props10.questionType,
        modalOpen = _this$props10.modalOpen,
        forceCloseButton = _this$props10.forceCloseButton;
      if (withModal) {
        return /*#__PURE__*/React.createElement(Modal, {
          show: modalOpen,
          onHide: this.handleCloseModal,
          animation: false,
          keyboard: !forceCloseButton,
          backdrop: forceCloseButton ? 'static' : true,
          size: "lg"
        }, /*#__PURE__*/React.createElement(Modal.Header, {
          closeButton: true,
          className: "no-border-bottom"
        }), /*#__PURE__*/React.createElement(Modal.Body, {
          className: "style-guide ".concat(hideFooterButton && 'hidden-footer')
        }, /*#__PURE__*/React.createElement("div", {
          className: "main-container"
        }, this.renderQuestions())), /*#__PURE__*/React.createElement(Modal.Footer, {
          className: "questions-container-nav-buttons justify-content-center ".concat(questionType, " ").concat(hideFooterButton || questionType === 'group_parent' ? 'd-none' : '')
        }, this.renderNavButtons()));
      }
      return /*#__PURE__*/React.createElement(Fragment, null, this.renderQuestions());
    }
  }]);
}(Component);
QuestionsContainer.propTypes = {
  questionnaireName: PropTypes.string.isRequired,
  questionIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  objectId: PropTypes.number,
  questionType: PropTypes.string,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  owner: PropTypes.bool,
  forceSmallQuestionTitle: PropTypes.bool,
  questionsUpdated: PropTypes.func,
  suggestedAnswers: PropTypes.shape([]),
  saveOnChange: PropTypes.bool,
  withModal: PropTypes.bool,
  hideFooterButton: PropTypes.bool,
  closeModalCallback: PropTypes.func,
  modalOpen: PropTypes.bool,
  paginated: PropTypes.bool,
  paginatedQuestionIds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  handleMenuUpdate: PropTypes.func,
  userId: PropTypes.number,
  loadButtons: PropTypes.func,
  handleNewResume: PropTypes.func,
  handleToggleSave: PropTypes.func,
  forceCloseButton: PropTypes.bool,
  isReadingMore: PropTypes.bool,
  handleResumeUpload: PropTypes.func,
  handlePastRolesAfterUpdate: PropTypes.func
};
QuestionsContainer.defaultProps = {
  questionType: '',
  objectId: null,
  owner: false,
  forceSmallQuestionTitle: false,
  questionsUpdated: function questionsUpdated() {},
  suggestedAnswers: null,
  saveOnChange: false,
  withModal: false,
  hideFooterButton: false,
  paginatedQuestionIds: [],
  closeModalCallback: function closeModalCallback() {},
  modalOpen: false,
  paginated: false,
  handleMenuUpdate: function handleMenuUpdate() {},
  userId: null,
  loadButtons: function loadButtons() {},
  handleNewResume: function handleNewResume() {},
  handleResumeUpload: function handleResumeUpload() {},
  handleToggleSave: function handleToggleSave() {},
  forceCloseButton: false,
  isReadingMore: false,
  handlePastRolesAfterUpdate: function handlePastRolesAfterUpdate() {}
};
export default QuestionsContainer;